
import { motion } from "framer-motion";

export function AnimatedLogo() {
  return (
    <motion.div
      className="relative w-12 h-12 flex items-center justify-center"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      {/* Outer glow */}
      <motion.div
        className="absolute inset-1 rounded-full bg-purple-300/20"
        animate={{
          boxShadow: [
            "0 0 10px 5px rgba(168, 85, 247, 0.3)",
            "0 0 15px 7px rgba(168, 85, 247, 0.4)",
            "0 0 10px 5px rgba(168, 85, 247, 0.3)"
          ],
          scale: [1, 1.05, 1]
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        style={{ borderRadius: '50%' }}
      />

      {/* Crystal ball outer sphere */}
      <motion.div
        className="absolute inset-2 rounded-full bg-purple-500/10 backdrop-blur-sm border border-white/20"
        animate={{
          boxShadow: [
            "inset 0 0 5px rgba(255, 255, 255, 0.5), 0 0 5px rgba(168, 85, 247, 0.3)",
            "inset 0 0 7px rgba(255, 255, 255, 0.6), 0 0 7px rgba(168, 85, 247, 0.4)",
            "inset 0 0 5px rgba(255, 255, 255, 0.5), 0 0 5px rgba(168, 85, 247, 0.3)"
          ]
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      {/* Core sphere */}
      <motion.div
        className="w-6 h-6 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center shadow-lg"
        animate={{
          scale: [1, 1.05, 1],
          boxShadow: [
            "0 0 5px 0 rgba(168, 85, 247, 0.4)",
            "0 0 10px 0 rgba(168, 85, 247, 0.6)",
            "0 0 5px 0 rgba(168, 85, 247, 0.4)"
          ]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      {/* Light ray */}
      <motion.div
        className="absolute inset-0 opacity-30"
        style={{
          background: 'radial-gradient(circle, rgba(139, 92, 246, 0.4) 0%, rgba(0,0,0,0) 70%)',
        }}
        animate={{
          opacity: [0.2, 0.4, 0.2]
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </motion.div>
  );
}
